export const initialState = {
  type: '',
  props: {},
  callback: () => {},
  open: false,
};
